export const FIELDS_DESCRIPTOR = {
  'sistematica': {},
  'impianto': {},
  'piattaforma': {},
  'collo': {},
  'chiusura': { restricted: true },
  'tipo_scan_abutment': {},
  'scan_abutment': { autocomplete: true },
  'indicazioni_uso': { autocomplete: true, restrictionsIssuer: true },
  'tecnica': {},
  'foro': {},
  'materiale': { extraInfo: true },
  'materia_prima': { extraInfo: true },
  'colore': {},
  'interfaccia': {},
  'includere_cappetta': {},
  'cappetta': {},
  't_connect': {},
  'angolazione': {},
  'h_cono': {},
  'transmucosa': {},
  'codice_interfaccia': {},
  'vite': {}
}
